/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './withdrawJoinRequest.defs.js'
export { main as default } from './withdrawJoinRequest.defs.js'
